/**
 * Accept term validation schema
 */

import { z } from "zod";

/**
 * Schema for accepting a term
 */
export const acceptTermArgsSchema = z.object({
  useTerm: z.object({
    id: z.number().positive("ID do termo deve ser positivo"),
    updatedAt: z.string().min(1, "Data de atualização é obrigatória"),
    accepted: z.boolean()
  }),
  user: z.object({
    id: z.number().positive("ID do usuário deve ser positivo")
  })
});
